<template>
  <div class="text-grey-darkest leading-normal paragraph">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'BaseParagraph',
};
</script>

<style lang="scss">
.paragraph {
  strong {
    font-weight: 600;
    color: #000;
  }
  ul {
    padding-left: 24px;
    list-style: none;
    margin-bottom: 16px;
    padding-top: 5px;
    li {
      &::before {
        content: "•";
        color: #FF6600;
        display: inline-block;
        width: 1em;
        margin-left: -1em;
      }

      &.ql-indent-1 {
        &::before {
          content: "-";
        }
        padding-left: 24px;
      }
    }
  }
}
</style>
